<!-- eslint-disable -->
<template>
  <CommonPages id="home" :class="['home']" :headerTheme="headerTheme" titlePrefix="Home"
    :metaDescription="domainConfig?.['meta']?.des || 'Default des'">
    <!-- 添加HomeHero组件 -->
    <!-- <HomeHero /> -->
    <HomeHero />

    <CarRecommend />

    <AdComponent v-if="deviceType !== 'mobile' && $global.isValidAdConfig(adsensConfig?.home_2)"
      ref="ads-home-2" class="ads-insert-full home-top-ad-padding" :ads="adsensConfig?.home_2"
      :showDebug="showDebug" />

    <div class="dashed-line" />

    <AdComponent v-if="deviceType === 'mobile' && $global.isValidAdConfig(adsensConfig?.home_3)"
      ref="ads-home-3-mobile" class="ads-insert-full home-top-ad-padding" :ads="adsensConfig?.home_3"
      :showDebug="showDebug" />

    <HomeSearch />

    <AdComponent v-if="deviceType !== 'mobile' && $global.isValidAdConfig(adsensConfig?.home_3)"
      ref="ads-home-3-pc" class="ads-insert-full home-top-ad-padding" :ads="adsensConfig?.home_3"
      :showDebug="showDebug" />

    <div class="dashed-line" />

    <AdComponent v-if="deviceType === 'mobile' && $global.isValidAdConfig(adsensConfig?.home_4)"
      ref="ads-home-4-mobile" class="ads-insert-full home-top-ad-padding" :ads="adsensConfig?.home_4"
      :showDebug="showDebug" />

    <CarPopular />

    <div class="dashed-line" />

    <CarNewRelease />

    <div class="dashed-line" />

    <CarRangRank />

    <div class="dashed-line" />

    <CarBrands />

    <div class="dashed-line" />

    <CarSellOffer />
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import AdComponent from '@/pages/components/AdComponent.vue'
import CommonPages from '@/pages/components/page_common.vue'
import CarRecommend from '@/components/CarRecommend.vue'
import CarType from '@/components/CarType'
import CarBrands from '@/components/CarBrands'
// import CarGallery from '@/components/CarGallery'
// import CarOffer from '@/components/CarOffer'
import CarPopular from '@/components/CarPopular.vue'
import CarRangRank from '@/components/CarRangRank.vue'
import CarNewRelease from '@/components/CarNewRelease.vue'
import HomeCarousel from '@/components/HomeCarousel.vue' // 导入HomeHero组件
import HomeSearch from '@/components/HomeSearch.vue' // 导入HomeHero组件
import HomeHero from '@/components/HomeHero.vue' // 导入HomeHero组件
import CarSellOffer from '@/components/CarSellOffer.vue' // 导入CarSellOffer组件

import '@/css/home.scss';

export default {
  name: 'Home',
  components: {
    AdComponent,
    CommonPages,
    CarRecommend,
    CarType,
    CarBrands,
    // CarGallery,
    // CarOffer,
    CarPopular,
    CarRangRank,
    CarNewRelease,
    HomeCarousel,
    HomeSearch,
    HomeHero, // 注册HomeHero组件
    CarSellOffer, // 注册CarSellOffer组件
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      cards: [],
      recommandList: [],
      hasNext: true,
      page: 1,
      observedAds: null,
      isLoading: false,
      scrollThreshold: 2000, // 滚动触发阈值
      scrollHandler: null,
      adLoadStatus: {}, // 记录广告加载状态
      adRetryCount: {}, // 记录广告重试次数
      maxAdRetries: 3, // 最大重试次数
      headerTheme: 'light', // 默认为light主题
      headerScrollThreshold: 50, // 滚动多少像素后改变header主题
      headerScrollHandler: null, // header滚动处理函数
    };
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'showDebug',
      'domainConfig'
    ]),
    storeCategories () {
      return this.$store.state.categories;
    },
    // 获取当前域名的组件顺序配置
    orderedComponents () {
      if (this.deviceType === 'mobile') {
        return [
          {
            "type": "HomeSearch",
            "id": "HomeSearch"
          },
          {
            "type": "CarRangRank",
            "id": "rangrank"
          },
          { "type": "Ad", "id": "ad_2", "showPC": false },
          {
            "type": "CarNewRelease",
            "id": "newrelease"
          },
          {
            "type": "CarPopular",
            "id": "popular"
          },
          { "type": "Ad", "id": "ad_1", "showPC": true },
          { "type": "Ad", "id": "ad_3", "showPC": false },
          {
            "type": "CarType",
            "id": "type"
          },
          {
            "type": "CarBrands",
            "id": "brands"
          }
        ];
      } else {
        return [
          {
            "type": "CarRecommend",
            "id": "recommend"
          },
          {
            "type": "CarRangRank",
            "id": "rangrank"
          },
          {
            "type": "CarNewRelease",
            "id": "newrelease"
          },
          {
            "type": "CarPopular",
            "id": "popular"
          },
          {
            "type": "CarType",
            "id": "type"
          },
          {
            "type": "CarBrands",
            "id": "brands"
          }
        ];
      }
    },
  },
  async beforeMount () {
    try {

      // 创建防抖的滚动处理函数
      // this.scrollHandler = this.debounce(this.onScroll, 200);

      // 检查URL参数是否有筛选条件
      this.checkUrlParams();
    } catch (error) {
      console.error('[Home] Created error:', error);
      // 可以添加错误提示或fallback逻辑
    }
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component activated`);
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component mounted`);
    }

    try {
      // 清理URL参数，如果存在筛选参数但不需要重定向
      this.cleanUrlParams();

      // 添加滚动监听
      window.addEventListener('scroll', this.scrollHandler);

      // 添加header主题滚动监听
      this.headerScrollHandler = this.debounce(this.onHeaderScroll, 50);
      window.addEventListener('scroll', this.headerScrollHandler);

      // 使用防抖包装滚动事件
      this.onScroll = this.debounce(this.onScroll.bind(this), 300);
      // 监听滚动事件
      window.addEventListener('scroll', this.onScroll);

      // 初始化header主题
      this.onHeaderScroll();

      // 在页面ready后执行showPos方法
      this.$nextTick(() => {
        setTimeout(() => {
          this.showPos();
        }, 1000); // 延迟1秒执行，确保页面元素已完全加载
      });

    } catch (error) {
      console.error('[Home] Ad system initialization error:', error);
      // 可以添加广告系统初始化失败的fallback逻辑
    }
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component beforeDestroy`);
    }

    // 清理定时器和事件监听
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }

    // 移除滚动监听
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
    }

    // 移除header主题滚动监听
    if (this.headerScrollHandler) {
      window.removeEventListener('scroll', this.headerScrollHandler);
    }

    // 组件销毁时移除滚动事件监听
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    //页面方法 ...

    // 优化后的滚动方法
    onScroll () {
      // 如果正在加载或没有更多数据，直接返回
      if (this.isLoading || !this.hasNext) {
        return;
      }

      const {
        scrollHeight,
        scrollTop,
        clientHeight
      } = document.documentElement;

      // 检查是否需要加载更多数据
      if (scrollHeight - scrollTop - clientHeight < this.scrollThreshold) {
        this.loadMoreData();
      }

      this.showPos();
    },
    // 显示当前屏幕可视范围内的广告坐标
    showPos () {
      console.log('执行showPos方法，显示当前可视范围内的广告坐标');

      // 获取所有广告元素
      const adElements = document.querySelectorAll('ins.adsbygoogle');
      const visibleAds = [];

      // 当前屏幕可视区域信息
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      // 遍历所有广告元素，找出在可视范围内的
      adElements.forEach((adElement) => {
        // 使用 getBoundingClientRect 获取元素相对于视口的位置
        const rect = adElement.getBoundingClientRect();

        // 检查元素是否在视口中可见（至少部分可见）
        // rect.top 和 rect.left 是相对于视口左上角的坐标
        const isVisible = !(
          rect.bottom < 0 ||   // 元素底部在视口顶部以上
          rect.top > windowHeight ||  // 元素顶部在视口底部以下
          rect.right < 0 ||  // 元素右侧在视口左侧以外
          rect.left > windowWidth  // 元素左侧在视口右侧以外
        );

        if (isVisible) {
          // 保持与 setupIframeTracking 方法中相同的数据格式
          const transformData = {
            insX: Math.round(rect.left),
            insY: Math.round(rect.top),
            insHeight: Math.round(rect.height),
            windowWidth: windowWidth,
            windowHeight: windowHeight
          };

          visibleAds.push(transformData);
        }
      });

      console.log('可视范围内的广告数量:', visibleAds.length);
      console.log('可视范围内的广告坐标:', visibleAds);

      // 即使没有可见广告，也会发送空数组
      this.$adPosition(JSON.stringify(visibleAds))
      return visibleAds;
    },

    // 加载更多数据
    async loadMoreData () {
      if (this.isLoading) return;

      try {
        this.isLoading = true;

        // 构建请求参数
        const params = {
          page: this.page,
          // 可以添加其他必要的参数
        };

        // 发起请求
        const res = await this.$global.server.getRecommend(params);

        if (res.code === 200) {
          const newData = res.data || [];

          // 更新数据
          this.recommandList = [...this.recommandList, ...newData];
          this.page += 1;

          // 检查是否还有更多数据
          this.hasNext = newData.length > 0;
        } else {
          throw new Error(res.message || '加载失败');
        }
      } catch (error) {
        console.error('[Home] Load more data error:', error);
        this.$message?.error?.('加载更多数据失败，请稍后重试');
        this.hasNext = false;
      } finally {
        this.isLoading = false;
      }
    },

    async getCategory () {
      try {
        const res = await this.$global.server.getCategory({});
        if (res.code === 200) {
          this.cards = res.data.types || [];
          // 更新store中的数据
          this.$store.commit('SET_CATEGORIES', this.cards);
        } else {
          throw new Error(`Failed to get categories: ${res.message || 'Unknown error'}`);
        }
      } catch (err) {
        console.error('[Home] Get category error:', err);
        // 可以添加用户提示
        this.$message?.error?.('获取分类失败，请稍后重试');
        throw err; // 向上传递错误，让调用者处理
      }
    },
    // 防抖函数
    debounce (func, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },

    //跳转
    async goto (name) {
      try {
        this.$router.push({ name });
      } catch (error) {
        console.error('[Home] Navigation error:', error);
      }
    },

    // 跳转到车辆详情页面
    gotoDetail (car) {
      try {
        // 检查是否有必要的参数
        if (!car || !car.id) {
          console.warn('[Home] Missing car data for detail page');
          return;
        }

        // 获取当前路由的channel参数
        const currentChannel = this.$router.currentRoute.params.channel;

        // 格式化车辆名称，去除空格，用连字符替代
        const formattedName = encodeURIComponent((car.model || car.name || '').replace(/\s+/g, '-'));

        // 如果存在channel参数，则构建带channel的路径
        if (currentChannel) {
          // 获取当前的查询参数
          const currentQuery = this.$route.query;
          const queryString = new URLSearchParams(currentQuery).toString();
          const fullQueryString = queryString ? `?${queryString}` : '';

          // 构建完整URL
          const baseUrl = window.location.origin;
          const fullPath = `${baseUrl}/${currentChannel}/cars/${formattedName}/${car.id}${fullQueryString}`;

          // 使用location跳转，保留所有参数
          window.location.href = fullPath;
        } else {
          // 没有channel参数，使用常规router跳转
          this.$router.push({
            path: `/cars/${formattedName}/${car.id}`
          });
        }
      } catch (error) {
        console.error('[Home] Detail navigation error:', error);
        this.$message?.error?.('页面跳转失败，请稍后重试');
      }
    },

    // 跳转到全部车辆页面
    gotoAll (type = '', brand = '') {
      try {
        // 构建查询参数
        const query = {};

        // 如果有类型参数，添加到查询中
        if (type) {
          query.purpose = type;
        }

        // 如果有品牌参数，添加到查询中
        if (brand) {
          query.brand = brand;
        }

        // 获取当前路由的channel参数
        const currentChannel = this.$router.currentRoute.params.channel;

        // 如果存在channel参数，则构建带channel的路径
        if (currentChannel) {
          // 转换查询参数为查询字符串
          const queryString = new URLSearchParams(query).toString();
          const fullQueryString = queryString ? `?${queryString}` : '';

          // 构建完整URL，car-list页面不需要格式化名称
          const baseUrl = window.location.origin;
          const fullPath = `${baseUrl}/${currentChannel}/car-list${fullQueryString}`;

          // 使用location跳转
          window.location.href = fullPath;
        } else {
          // 没有channel参数，使用常规router跳转
          this.$router.push({
            path: '/car-list',
            query: query
          });
        }
      } catch (error) {
        console.error('[Home] All cars navigation error:', error);
        this.$message?.error?.('页面跳转失败，请稍后重试');
      }
    },

    gotoSort (type) {
      try {
        if (!type) {
          console.warn('[Home] Invalid type for navigation');
          return;
        }

        // 对特殊字符进行编码
        const formattedType = encodeURIComponent(type.replace(/\s+/g, '-'));
        const channel = this.$router.currentRoute.params.channel
          ? `/${this.$router.currentRoute.params.channel}`
          : '';

        // 构建完整URL
        const baseUrl = window.location.origin;
        const queryString = new URLSearchParams(this.$route.query).toString();
        const fullQueryString = queryString ? `?${queryString}` : '';
        const fullUrl = `${baseUrl}${channel}/${formattedType}${fullQueryString}`;

        window.location.href = fullUrl;
      } catch (error) {
        console.error('[Home] Sort navigation error:', error);
        this.$message?.error?.('Navigation failed, please try again later');
      }
    },

    // 检查URL参数
    checkUrlParams (shouldRedirect = false) {
      const { purpose, brand } = this.$route.query;
      if ((purpose || brand) && shouldRedirect) {
        // 如果URL中有筛选参数且允许重定向，跳转到car-list页面
        this.gotoAll(purpose, brand);
      }
    },

    // 清理URL参数，移除all页面的筛选参数
    cleanUrlParams () {
      const { query } = this.$route;

      // 需要清理的参数列表
      const paramsToClean = ['purpose', 'brand', 'type', 'price', 'fuel', 'page', 'fromPage'];

      // 检查是否有需要清理的参数
      const hasParamsToClean = paramsToClean.some(param => query[param] !== undefined);

      if (hasParamsToClean) {
        console.log('[Home] Cleaning URL parameters from all page');

        // 使用replace方法替换路由，不会添加新的历史记录
        this.$router.replace({
          path: this.$route.path
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },

    // 检查是否应该在特定位置插入广告
    shouldInsertAdDevice (pos, index) {
      try {
        // 如果没有广告配置,直接返回 -1
        if (!this.adPosConfig?.[pos]) {
          return -1;
        }

        const position = index + 1;
        const config = this.adPosConfig[pos];

        // 区分移动端和PC端的广告位置配置
        const adPositions = this.deviceType === 'mobile'
          ? config.mobile || []
          : config.pc || [];

        if (!Array.isArray(adPositions)) {
          return -1;
        }

        const adIndex = adPositions.indexOf(position);

        // 检查对应位置是否有广告配置
        if (adIndex !== -1) {
          const adConfig = this.deviceType === 'mobile'
            ? this.adsensConfig?.[pos]?.mobile?.[adIndex]
            : this.adsensConfig?.[pos]?.pc?.[adIndex];

          if (!this.$global.isValidAdConfig(adConfig)) {
            if (process.env.NODE_ENV === 'development') {
              console.warn(`[Home] Missing ad config for position ${pos} index ${adIndex} on ${this.deviceType}`);
            }
            return -1;
          }
        }

        return adIndex;
      } catch (error) {
        console.error('[Home] Ad position check error:', error);
        return -1;
      }
    },

    // 获取广告配置
    getAdConfig (pos, index) {
      try {
        const adIndex = this.shouldInsertAdDevice(pos, index);
        if (adIndex === -1) return null;

        const config = this.deviceType === 'mobile'
          ? this.adsensConfig?.[pos]?.mobile?.[adIndex]
          : this.adsensConfig?.[pos]?.pc?.[adIndex];

        return this.$global.isValidAdConfig(config) ? config : null;
      } catch (error) {
        console.error('[Home] Get ad config error:', error);
        return null;
      }
    },

    // 处理广告加载成功
    handleAdLoad (pos, index, event) {
      const adKey = `${pos}_${index}`;
      this.adLoadStatus[adKey] = true;
      this.adRetryCount[adKey] = 0;

      if (process.env.NODE_ENV === 'development') {
        console.log(`[Home] Ad loaded successfully: ${adKey}`, event);
      }
    },

    // 处理广告加载失败
    handleAdError (pos, index, error) {
      const adKey = `${pos}_${index}`;
      this.adLoadStatus[adKey] = false;
      this.adRetryCount[adKey] = (this.adRetryCount[adKey] || 0) + 1;

      console.error(`[Home] Ad load error for ${adKey}:`, error);

      // 如果未超过最大重试次数，尝试重新加载
      if (this.adRetryCount[adKey] < this.maxAdRetries) {
        setTimeout(() => {
          this.retryLoadAd(pos, index);
        }, 1000 * this.adRetryCount[adKey]); // 递增重试延迟
      }
    },

    // 重试加载广告
    retryLoadAd (pos, index) {
      const adKey = `${pos}_${index}`;
      if (process.env.NODE_ENV === 'development') {
        console.log(`[Home] Retrying ad load for ${adKey}, attempt ${this.adRetryCount[adKey]}`);
      }

      // 获取广告组件引用
      const adRef = this.$refs[`ads-${pos}-${index}`];
      if (adRef && adRef[0]?.reload) {
        adRef[0].reload();
      }
    },

    // 处理header主题切换的滚动事件
    onHeaderScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // 如果滚动超过阈值，切换到dark主题
      if (scrollTop > this.headerScrollThreshold) {
        this.headerTheme = 'dark';
      } else {
        // 否则使用light主题
        this.headerTheme = 'light';
      }
    },

    // 根据广告ID获取对应配置
    getAdConfigById (adId) {
      try {
        // 默认使用home_insert广告组
        const adGroup = 'home_insert';
        const adIndex = this.getAdIndexFromId(adId);

        if (adIndex === -1) return null;

        // 根据设备类型获取相应的广告配置
        const config = this.deviceType === 'mobile'
          ? this.adsensConfig?.[adGroup]?.mobile?.[adIndex]
          : this.adsensConfig?.[adGroup]?.pc?.[adIndex];

        return this.$global.isValidAdConfig(config) ? config : null;
      } catch (error) {
        console.error(`[Home] Error getting ad config for ${adId}:`, error);
        return null;
      }
    },

    // 从广告ID中提取索引
    getAdIndexFromId (adId) {
      try {
        // 假设adId的格式为"ad_数字"，提取数字部分
        const matches = adId.match(/ad_(\d+)/);
        if (matches && matches[1]) {
          return parseInt(matches[1]) - 1; // 转为0基索引
        }
        return -1;
      } catch (error) {
        console.error(`[Home] Error parsing ad ID ${adId}:`, error);
        return -1;
      }
    },
  }
};
</script>
